<template>
  <div grid-list-xl class="margin-auto">
    <v-container grid-list-xl class="margin-auto no-padding">
      <v-flex xs12>
        <v-form
          ref="formRepresentante"
          lazy-validation
          v-for="(representante, index) in representantesLegais"
          :key="index"
        >
          <v-layout row wrap form-padding class="contact-row">
            <v-flex xs1 offset-xs11 class="flex-close">
              <v-icon
                class="close_icon"
                @click="removerRepresentante(index)"
                v-if="representantesLegais.length > 1"
                >close</v-icon
              >
            </v-flex>

            <v-flex md3 sm12>
              <v-text-field
                class="form-input-box"
                label="CPF"
                id="cpf"
                v-model="representante.documento"
                :rules="[rules.obrigatorio, rules.documentoInvalido]"
                v-mask="'###.###.###-##'"
                placeholder=" "
              ></v-text-field>
            </v-flex>

            <v-flex sm12 :class="ativaEmail ? 'md9' : 'md6'">
              <v-text-field
                class="form-input-box"
                label="Nome"
                id="nome"
                v-model="representante.nome"
                :rules="[rules.obrigatorio]"
                placeholder=" "
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm12>
              <v-text-field
                class="form-input-box"
                label="Cargo/Função"
                id="cargo"
                v-model="representante.cargo"
                :rules="[rules.obrigatorio]"
                placeholder=" "
              ></v-text-field>
            </v-flex>

            <v-flex md9 sm12 v-if="ativaEmail">
              <v-text-field
                class="form-input-box"
                label="E-mail"
                id="nome"
                v-model="representante.email"
                :rules="[rules.obrigatorio, rules.email]"
                placeholder=" "
              ></v-text-field>
            </v-flex>

            <v-flex v-show="representante.pep" md3 sm12>
              <v-autocomplete
                v-model="representante.categorias_pep_selected"
                :items="categoriasPeps"
                :label="'Pessoa politicamente exposta'"
                id="categoriaPep"
                :error="representante.hasError"
                :error-messages="
                  representante.hasError ? 'Campo obrigatório' : ''
                "
                chips
                small-chips
                @click:append="
                  mostraModalCategoriasPep = true;
                  indexRepresentante = index;
                "
                @mousedown="
                  mostraModalCategoriasPep = true;
                  indexRepresentante = index;
                "
                item-text="descricao"
                item-value="id"
                class="form-select-box"
                multiple
                placeholder=" "
                return-object
              >
                <template slot="selection" slot-scope="data">
                  <v-chip
                    :selected="data.selected"
                    class="chip--select-multi"
                    @mouseover="data.item.tooltipShow = true"
                    @mouseout="data.item.tooltipShow = false"
                    >{{ data.item.enumerador }}</v-chip
                  >

                  <v-tooltip
                    max-width="500"
                    v-model="data.item.tooltipShow"
                    bottom
                  >
                    <v-icon slot="activator"></v-icon>
                    <span v-html="data.item.descricao"></span>
                  </v-tooltip>
                </template>
                <template slot="item" slot-scope="data">
                  {{ data.item }}
                </template>
              </v-autocomplete>
            </v-flex>

            <v-flex
              md4
              sm12
              :class="representante.pep ? 'offset-md5' : 'offset-md8'"
            >
              <v-switch
                @change="setPep(index, representante)"
                v-model="representante.pep"
                id="pep"
                label="Pessoa politicamente exposta?"
                class="float-right"
              ></v-switch>
            </v-flex>
          </v-layout>
          <hr style="margin-bottom: 1vh" />
        </v-form>
      </v-flex>

      <v-flex xs12 text-xs-center>
        <a
          href
          @click.prevent="
            representantesLegais.push({
              categorias_pep_selected: [],
              categorias_pep: [],
              pep: false,
              hasError: false,
            });
            $forceUpdate();
          "
          class="add-new"
        >
          <v-icon>add_circle_outline</v-icon>Adicionar responsáveis
        </a>
      </v-flex>
    </v-container>

    <v-dialog v-model="mostraModalCategoriasPep" persistent max-width="120vh">
      <main id="selecionar-empresa" class="ohx login-modal">
        <v-content class="ohx">
          <v-container fluid grid-list-xs class="white-background ohx pb-4">
            <v-flex xs12 class="title-categoria-pep">
              <h4 mb-2>Pessoa publicamente exposta</h4>
              <h2 mb-2>Selecione abaixo as opções correspondentes:</h2>
            </v-flex>

            <v-layout row wrap>
              <v-container class="container-card-categoria-pep no-padding">
                <v-card
                  class="card-categoria-pep"
                  v-for="(categoria, index) in categoriasPeps"
                  :key="index"
                >
                  <v-layout row wrap class="layout-categoria-pep">
                    <v-flex md1 sm2 xs2 class="flex-categoria">
                      <div class="content-enumerador">
                        {{ categoria.enumerador }}
                      </div>
                    </v-flex>
                    <v-flex md10 sm8 xs8 class="flex-categoria-pep">{{
                      categoria.descricao
                    }}</v-flex>
                    <v-flex md1 sm2 xs2 class="flex-categoria">
                      <i
                        class="material-icons content-icon-check"
                        v-if="categoriaPepSelected(categoria)"
                        @click="removeCategoriaPep(categoria)"
                        >check_box</i
                      >
                      <i
                        class="material-icons content-icon-no-check"
                        v-if="!categoriaPepSelected(categoria)"
                        @click="selectCategoriaPep(categoria)"
                        >check_box_outline_blank</i
                      >
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-container>

              <v-flex md3 offset-md9 sm12>
                <button
                  @click="mostraModalCategoriasPep = false"
                  class="button jns-button yellow-button pep-button"
                >
                  OK
                </button>
              </v-flex>
            </v-layout>
          </v-container>
        </v-content>
      </main>
    </v-dialog>
  </div>
</template>

<script lang="js">
import { isValidCnpj, isValidCpf } from "@/libs/utils";

export default {
  name: "PessoaPoliticamenteExpostaComponent",
  data() {
    return {
      indexRepresentante: 0,
      mostraModalCategoriasPep: false,
      rules: {
        obrigatorio: (v) => !!v || "Campo obrigatório",
        email: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail inválido",
        documentoInvalido: (v) =>
          (!!v &&
            (v.length > 14
              ? isValidCnpj(v)
              : isValidCpf(v))) ||
          "Documento inválido",
      },
    };
  },
  props: ["representantesLegais", "categoriasPeps", "ativaEmail"],
  methods: {
    categoriaPepSelected(item) {
      var isSelected = false;

      if (
        this.representantesLegais[this.indexRepresentante]
          .categorias_pep_selected
      )
        for (
          var i = 0;
          i <
          this.representantesLegais[this.indexRepresentante]
            .categorias_pep_selected.length;
          i++
        )
          if (
            item.id ==
            this.representantesLegais[this.indexRepresentante]
              .categorias_pep_selected[i].id
          )
            isSelected = true;

      return isSelected;
    },

    selectCategoriaPep(item) {
      this.representantesLegais[
        this.indexRepresentante
      ].categorias_pep_selected.push(item);
      this.representantesLegais[this.indexRepresentante].categorias_pep.push({
        id: item.id,
      });

      this.$emit("validaCategoriaPep", this.indexRepresentante);
      this.$forceUpdate();
    },

    setPep(index, representante) {
      if (!representante.pep) representante.categorias_pep_selected = [];
      else {
        this.mostraModalCategoriasPep = true;
        this.indexRepresentante = index;
      }

      this.$forceUpdate();
    },

    setCategoriasPep() {
      this.representantesLegais.forEach((representante) => {
        if (
          representante.categorias_pep &&
          representante.categorias_pep.length > 0
        )
          representante.categorias_pep.forEach((item) => {
            this.categoriasPeps.forEach((element) => {
              if (element.id == item.id)
                representante.categorias_pep_selected.push(element);
            });
          });
      });
    },

    removeCategoriaPep(item) {
      let index = this.representantesLegais[
        this.indexRepresentante
      ].categorias_pep_selected.indexOf(item);

      if (index >= 0) {
        this.representantesLegais[
          this.indexRepresentante
        ].categorias_pep_selected.splice(index, 1);
        this.representantesLegais[
          this.indexRepresentante
        ].categorias_pep.splice(index, 1);
      }

      this.$emit("validaCategoriaPep", this.indexRepresentante);
      this.$forceUpdate();
    },

    removerRepresentante(index) {
      this.representantesLegais.splice(index, 1);
      this.$forceUpdate();
    },
  },
  created() {
    if (!this.representantesLegais || !this.representantesLegais.length) {
      this.representantesLegais.push({
        categorias_pep_selected: [],
        categorias_pep: [],
        pep: false,
        hasError: false,
      });
    } else {
      this.representantesLegais.forEach((item) => {
        item.categorias_pep_selected = [];

        item.categorias_pep.forEach((categoria) => {
          this.categoriasPeps.forEach((filtro) => {
            if (filtro.id == categoria.id)
              item.categorias_pep_selected.push(filtro);
          });
        });
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.margin-auto {
  margin: auto;
}

@media (max-width: 600px) {
  .container-card-categoria-pep {
    .card-categoria-pep {
      height: 50% !important;
      overflow: auto;
    }
  }

  .pep-button {
    margin-top: 1vh;
  }
}

.title-categoria-pep {
  text-align: center;
  margin-bottom: 5vh;
  color: #061d45;
}
.container-card-categoria-pep {
  height: 60vh;
  overflow: auto;
  .card-categoria-pep {
    margin-bottom: 3vh;
    padding: 1vh;
    height: 13vh;

    .layout-categoria-pep {
      height: 8vh;

      .flex-categoria {
        padding: 3.3vh 2vh;

        .content-enumerador {
          text-align: center;
          font-weight: bold;
          background-color: #28249852;
          color: #282498;
          font-size: 3vh;
          height: 4vh;
          width: 4vh;
        }

        .content-icon-check {
          font-size: 5vh;
          color: #282498;
        }

        .content-icon-no-check {
          font-size: 5vh;
        }
      }

      .flex-categoria-pep {
        font-size: 1.8vh;
        height: 8vh;
      }
    }
  }
}

.v-chip {
  background-color: #28249852;
  color: #282498;
  font-weight: bold;
  border-radius: 0;
  font-size: 3vh;
}

.icon-color {
  color: #282498;
}

.container {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// ./src/components/PessoaPoliticamenteExpostaComponent.vue